import Header from "@/components/Header";
import Footer from "@/components/Footer";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-6 pt-28 pb-16 max-w-3xl">
        <h1 className="font-display text-3xl font-bold text-foreground mb-8">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: March 3, 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/80">
          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using bnbxo ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">2. Description of Service</h2>
            <p>bnbxo is a price comparison tool that helps users find better deals on short-term rental accommodations by comparing Airbnb listing prices with alternative booking platforms. We do not facilitate bookings directly.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">3. Use of Service</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You must be at least 18 years old to use this Service.</li>
              <li>You agree to use the Service only for lawful purposes.</li>
              <li>You will not attempt to interfere with or disrupt the Service.</li>
              <li>You will not use automated systems to scrape or extract data from the Service beyond normal usage.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">4. Accuracy of Information</h2>
            <p>While we strive to provide accurate pricing information, we cannot guarantee that all prices, availability, or listing details are always up to date. Prices are subject to change and may vary based on dates, availability, and other factors. Always verify pricing on the booking platform before completing a reservation.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">5. Intellectual Property</h2>
            <p>All content, features, and functionality of the Service—including but not limited to text, graphics, logos, and software—are the property of bnbxo and are protected by intellectual property laws.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">6. Limitation of Liability</h2>
            <p>bnbxo is provided "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount you have paid to use the Service.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">7. Third-Party Links</h2>
            <p>The Service may contain links to third-party websites or booking platforms. We are not responsible for the content, policies, or practices of any third-party sites.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">8. Termination</h2>
            <p>We reserve the right to suspend or terminate your access to the Service at any time, without notice, for conduct that we believe violates these Terms or is harmful to other users or the Service.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">9. Changes to Terms</h2>
            <p>We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-3">10. Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us at <a href="mailto:hello@bnbxo.com" className="text-primary hover:underline">hello@bnbxo.com</a>.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
